export const openExternally = (url: string) => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openLink) {
    // @ts-ignore
    window.webkit.messageHandlers.openLink.postMessage(url);
  } else {
    alert('Native bridge not available.\nWill try fallback.');
    window.open(url, '_blank');
  }
}

export const logoutTrigger = () => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
    // @ts-ignore
    window.webkit.messageHandlers.logout.postMessage(null);
  } else {
    alert('Native bridge not available.\nWill try fallback.');
    document.location.href = '/logout';
  }
}

export const paymentTrigger = (productId: string) => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.pay) {
    // @ts-ignore
    window.webkit.messageHandlers.pay.postMessage(productId);
  } else {
    alert('Native bridge not available.\nWill try fallback.' + productId);
  }
}
export const hasIosAppReviewCapability = (): boolean => {
  // @ts-ignore
  return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.review);
}
//review
export const requestIosAppReview = () => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.review) {
    // @ts-ignore
    window.webkit.messageHandlers.review.postMessage(null);
  } else {
    alert('Native bridge not available.\nWill try fallback.');
  }
}